import React from "react";
import { View } from "react-native";

import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cr from "./_cr";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";

import { useMdlz } from "./_csMdl";

import { a } from './_cmABT';

export const R = (pz: {
  children: React.FC,
}) => {

  const _sMdlz = useMdlz();

  const _clsMdl = () => {
    _sMdlz.set({
      bShow: false,
    });
    if (_sMdlz.crt.onCls) _sMdlz.crt.onCls();
  };

  return (
    _cr.c(View, {
      style: {
        width: '100%',
        height: '100%',
      }
    }, [

      pz.children,

      _sMdlz.crt.bShow ?
      _cr.c(BoxC.N, {
        key: -20,
        boxStlz: a('sc/sk5 dh/f dw/f dp/a dz/mdl dt/0 dl/0'),
        boxClds: [

          _cr.c(BoxC.N, { // mask
            key: -10,
            boxStlz: a('dp/a dz/mdl+1 dt/0 dl/0 dh/f dw/f'),
            pslStlz: a(`dh/f dw/f`),
            pslPtyz: {
              onPrs: _clsMdl,
            },
          }),

          _cr.c(BoxC.N, { // main
            key: -20,
            boxStlz: a('fd/ccc db/h dp/a dl/h dr/h dt/h dz/mdl+2 sc/lt9'),
            boxClds: [

              _cr.c(BoxC.N, { // 閉じるボタンの幅を mdlClds と合わせるために必要
                boxClds: [

                  _sMdlz.crt.bCls ?
                  _cr.c(BtnC.N, {
                    key: -20,
                    lblCz: {
                      text: `閉じる`,
                      textStlz: a(`tb tc/lt3 ts/s`),
                    },
                    frmCz: {
                      boxStlz: a(`br/0.5 dh/f dw/f fd/ccc sc/lt5`),
                      pslStlz: a(`dh/3 dw/f mb/2`), // 閉じるボタンの表示位置を調整するために必要
                      pslPtyz: {
                        onPrs: _clsMdl
                      }
                    }
                  })
                  : undefined,

                  _sMdlz.crt.mdlClds,

                ]
              })

            ],

          }),

        ],
      })
      : undefined

    ])


  );
};
